import React from "react";
import { Modal } from "react-bootstrap";
import { MuxInfoRedCircle } from "@/Icons";
import {
  groupUsagesByType,
  getTypeLabels,
  renderUsageGroup,
} from "./usageGroupingUtils";
import { DeletionPreventionModalProps } from "@/interfaces";
import styles from "./DeletionPreventionModal.module.scss";

export const DeletionPreventionModal: React.FC<
  DeletionPreventionModalProps
> = ({ show, onHide, title, usedInLabel, deletionPreventionData }) => {
  if (!show || !deletionPreventionData) return null;

  const typeLabels = getTypeLabels();
  const fields = deletionPreventionData.fields || [
    {
      field_name: "",
      message: deletionPreventionData.message || "",
      usages: deletionPreventionData.usages || [],
    },
  ];

  return (
    <Modal
      show={show}
      size="lg"
      backdrop="static"
      centered={true}
      keyboard={false}
      onHide={onHide}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <span className={styles.deletionPreventionIcon}>
            <MuxInfoRedCircle />
          </span>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.deletionPreventionModalContent}>
          {fields.map((field) => {
            const usages = field.usages || [];
            const groupedUsages = groupUsagesByType(usages);
            return (
              <div key={field.field_name}>
                <p className={styles.deletionPreventionMessage}>
                  {field.message}
                </p>
                {usages.length > 0 && (
                  <div className={styles.deletionPreventionUsages}>
                    <p className={styles.deletionPreventionUsagesTitle}>
                      {usedInLabel}
                    </p>
                    <div className={styles.deletionPreventionUsagesList}>
                      {Object.entries(groupedUsages).map(
                        ([type, usages]: [string, any]) =>
                          renderUsageGroup(type, usages, typeLabels, styles),
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
};
